import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
//import netlifyIdentity from 'netlify-identity-widget';

import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';

import getMuiTheme from 'material-ui/styles/getMuiTheme';

const muiTheme = getMuiTheme({
    fontFamily: "Roboto, Sans-Serif",
    palette: {
      textColor:"black",
      primary1Color:"black",
      accent1Color: "#FF0000",
      primary1ColorHover:"black"
    },  
    floatingActionButton: {
      buttonSize: 30
    },
    appBar: {
      height: 48,
      color: "white",
      textColor: "black"
    },
    toolbar:{
        height: 48
    },
    datePicker: {
      color: "red",
      // textColor: palette.alternateTextColor,
      // calendarTextColor: palette.textColor,
      selectColor: "#47BEA7",
      // selectTextColor: palette.alternateTextColor,
      // calendarYearBackgroundColor: palette.canvasColor,
      // headerColor: palette.pickerHeaderColor || palette.primary1Color,      
    }
  });

//netlifyIdentity.init();

ReactDOM.render(<MuiThemeProvider muiTheme={muiTheme}>
                    <App />
                </MuiThemeProvider>, 
                document.getElementById('root'));

registerServiceWorker();
